export default function ({ store, redirect, localePath }) {
  store.commit("general/SET_DESKTOP_MENU", null);
  store.commit("general/SET_SIDE_MENU", false);
  store.commit("general/SET_MOBILE_MENU", false);
}